window.Page = {

    slidesContainers : document.querySelectorAll('.progetto-edizione-slider'),

    // Let's launch this thing
    liftoff : () => {
        Page.initSlideSections()
    },

    // My new function block
    initSlideSections : () => {
        Page.slidesContainers.forEach(slider => {
            let flkty = new Flickity( slider, {
                cellAlign       : 'left',
                contain         : true,
                prevNextButtons : false,
                pageDots        : false,
                watchCSS        : false,
                imagesLoaded    : true,
            });

            // Update the counter on slide change
            flkty.on('change', function (index){
                slider.parentElement.parentElement.querySelector('.progetto-edizione-current').innerHTML = index + 1;
            });

        })
    }

};

Page.liftoff()